(function () {
    'use strict';

    function requestForProposalResponseDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/';

        function loadRequestForProposalResponse(id) {
            return $http.get(baseUrl + id).then(function (response) {
                return response.data;
            });
        };

        function loadRequestForProposalResponsesForRequestForProposal(id) {
            return $http.get(baseUrl + 'requestforproposalresponses/' + id).then(function (response) {
                return response.data;
            });
        };

        function createRequestForProposalResponse(data) {
            return $http.post(baseUrl + 'requestforproposalresponses', data).then(
                function (response) { return response.data; }
            );
        };

        function saveRequestForProposalResponse(data) {
            return $http.put(baseUrl + data.Id, data).then(
                function (response) { return true; }
            );
        };

        function deleteUploadBlob(blobReference) {
            return $http.get('/Files/DeleteUploadBlob?blobReference=' + blobReference).then(
                function (response) { return response.data; });
        };


        function deleteRequestForProposalResponse(id) {
            return $http.delete(baseUrl + id).then(function (response) {
                return response.data;
            });
        }

        return {
            loadRequestForProposalResponse: loadRequestForProposalResponse,
            loadRequestForProposalResponsesForRequestForProposal: loadRequestForProposalResponsesForRequestForProposal,
            createRequestForProposalResponse: createRequestForProposalResponse,
            saveRequestForProposalResponse: saveRequestForProposalResponse,
            deleteUploadBlob: deleteUploadBlob,
            deleteRequestForProposalResponse: deleteRequestForProposalResponse
        }
    }

    requestForProposalResponseDataService.$inject = ['$http'];

    angular.module('ecap.common').service('requestForProposalResponseDataService', requestForProposalResponseDataService);
})();
